import { REGEX_PHONE_NUMBER } from "constants/common/common";
import * as yup from "yup";

export const createValidationSchema = yup.object().shape({
  code: yup.string().min(2, "Mã đối tác phải có ít nhất 2 ký tự"),
  name: yup
    .string()
    .min(2, "Tên đối tác phải có ít nhất 2 ký tự")
    .max(200, "Tên đối tác không được vượt quá 200 ký tự")
    .required("Vui lòng nhập tên đối tác"),
  type: yup.string().required("Vui lòng chọn loại đối tác"),
  regionId: yup.string().required("Vui lòng chọn địa bàn"),
  phone: yup
    .string()
    .matches(REGEX_PHONE_NUMBER, { message: "Số điện thoại không hợp lệ", excludeEmptyString: true })
    .optional(),
  taxCode: yup.string().required("Vui lòng nhập mã số thuế"),
  contactPersonId: yup.string().optional(),
  notes: yup.string().nullable().optional(),
});
